import React, { useCallback } from 'react'
import { Checkbox } from '@zambezi/sdk/form-elements'
import { Icon } from '@zambezi/sdk/icons'

/**
 * Create a React Selectable Cell component
 *
 * @param {import('./interfaces').SelectableCellProps} props
 * @returns {JSX.Element}
 */
export default function SelectableCell ({
  children,
  rowIndex,
  onRowSelect,
  isChecked,
  heading,
  cellProps,
  Cell,
  open,
  onToggleClick,
  id
}) {
  const handleRowSelection = useCallback(
    (event, isChecked) => {
      onRowSelect(rowIndex, event, isChecked)
    },
    [rowIndex, onRowSelect]
  )
  const handleToggle = useCallback(
    event => {
      const {
        type,
        key,
        target: {
          dataset: { open }
        }
      } = event
      const isSpace = key === ' ' || key === 'Spacebar'
      if (type === 'click' || key === 'Enter' || isSpace) {
        if (isSpace) event.preventDefault()
        onToggleClick(open === 'true')
      }
    },
    [onToggleClick]
  )

  return (
    <Cell data-heading={heading} {...cellProps}>
      <Checkbox
        id={id}
        checked={isChecked}
        value={String(rowIndex)}
        onChange={handleRowSelection}
      />
      <label htmlFor={id} id={`${id}-label`}>{children}</label>
      <Icon
        role='button'
        aria-pressed={open}
        data-open={open}
        tabIndex='0'
        onClick={handleToggle}
        onKeyDown={handleToggle}
        title={open ? 'Collapse' : 'Expand'}
        className='zb-table-accordion-toggle'
        name={open ? 'core-accordion-collapse' : 'core-accordion-expand'}
        size='small'
      />
    </Cell>
  )
}
